// @ts-nocheck

import { CREATE_TUNE_CUSTOM_EXPORT, RETRIEVE_TUNE_CUSTOM_EXPORTS } from '../../actions/TuneCustomExportActions';
import { LOADING_STATUS } from '../../support/constants';
import { reducerWrapper } from '../../support/utils';
import type { CustomExportReducer } from '../../types/customExportTypes';
import { processExportInfo } from './customExportReducerUtils';
export const INIT_STATE: CustomExportReducer = {
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  exports: [],
};

function Handler(state: CustomExportReducer = INIT_STATE, action) {
  switch (action.type) {
    case CREATE_TUNE_CUSTOM_EXPORT.response:
    case RETRIEVE_TUNE_CUSTOM_EXPORTS.response:
      return !action.data || !action.data.length
        ? { ...state, loadingStatus: LOADING_STATUS.LOADED }
        : { ...state, loadingStatus: LOADING_STATUS.LOADED, exports: processExportInfo(action.data) };

    default:
      return state;
  }
}

const TuneCustomExport = reducerWrapper(INIT_STATE, Handler, {
  request: [CREATE_TUNE_CUSTOM_EXPORT, RETRIEVE_TUNE_CUSTOM_EXPORTS],
  error: [CREATE_TUNE_CUSTOM_EXPORT, RETRIEVE_TUNE_CUSTOM_EXPORTS],
});
export default TuneCustomExport;
